import { matchUrlExact } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import type { MatcherLocation } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/types.tsx';

const VIEW_AUDITING_PATH_REGEXP = /\/auditing\/(\w+)/i;

export const isViewAuditingSelected = (
	currentLocation: MatcherLocation,
	itemLocation: MatcherLocation,
): boolean =>
	matchUrlExact()(currentLocation, itemLocation) ||
	VIEW_AUDITING_PATH_REGEXP.test(currentLocation.pathname);
